// removed by extract-text-webpack-plugin
module.exports = {"sliderItem":"_2ZZ59o9Ozt_9cAf5HbD8n6","logoWrapper":"eErmo3ylyJn-CDNy7p1q5","logo":"_3KeuclEbBOjX2jWxKQp-Cx","description":"_23YscFTpbDCk3YbNYJLFG5","sliderItemWrapper":"_1-ayarALpMzwHFqW-HF6Cd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProfessionalCellSmall/ProfessionalCellSmall.scss
// module id = 1676
// module chunks = 0